import { DEFAULT_ELEMENT_CONTAINER_PROPS } from '@kizen/page-builder/nodes/containers/ElementContainer';

export const DEFAULT_FORM_FIELD_PROPS = {
  ...DEFAULT_ELEMENT_CONTAINER_PROPS,
  containerPaddingTop: '10',
  containerPaddingRight: '10',
  containerPaddingBottom: '10',
  containerPaddingLeft: '10',
};
